// constants.js
// Features:
// - Central configuration for global timing and animation values

export const OVERLAY_FADE_DURATION_SEC = 2.5
export const OVERLAY_FADE_DURATION_MS = OVERLAY_FADE_DURATION_SEC * 1000
